export enum ValidationTypes {
	required = 'required',
	email = 'email',
	name = 'name',
	number = 'number',
	password = 'password',
	username = 'username',
}
